let addOnsSlider = null;
const AJAX_CART_ENABLE = true;

(function () {
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSlider, 200);
  });

  // Bind the cart handler before optional add-on UI initialization so a fast
  // click can never fall through to Shopify's native /cart redirect.
  initAddToCart();
  initSlider();

  initAddonSelection();
  initAddonModals();
  inputProductOptionSelection();
})();



function initSlider() {
  const sliderContainer = document.querySelector('.swiper-container-addons');
  if (!sliderContainer) return;

  if (addOnsSlider) {
    addOnsSlider.destroy();
    addOnsSlider = null;
  }

  addOnsSlider = new Swiper(".swiper-container-addons", {
    mousewheel: {
      invert: false,
      interval: 400
    },
    ...getSwiperConfig(),
    initialSlide: 0,
    navigation: {
      prevEl: ".swiper-plugin-navigation-prevEl",
      nextEl: ".swiper-plugin-navigation-nextEl"
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, // Allows clicking dots to navigate
    },
    plugins: [
      SwiperPluginNavigation,
      SwiperPluginPagination,
    ]
  });

  document.querySelector('.addons-slider .swiper-nav-next').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const nextSlide = addOnsSlider.state.index + addOnsSlider.options.slidesPerGroup;
    addOnsSlider.slideTo(nextSlide);
  });

  document.querySelector('.addons-slider .swiper-nav-prev').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const nextSlide = addOnsSlider.state.index - addOnsSlider.options.slidesPerGroup;
    addOnsSlider.slideTo(nextSlide);
  });
}

/**
 * Initialize add-ons selection
 */
/**
 * Funnel fields for one add-on card, in the shape the shared tracker wants.
 * Same surface vocabulary as the cart drawer row and the checkout modal, so the
 * three can actually be compared rather than just each reported.
 */
function addonTrackFields(card) {
  if (!card) return null;
  const cards = Array.prototype.slice.call(document.querySelectorAll('.product-addons__card[data-addon-card]'));
  return {
    surface: (window.mgUpsell && window.mgUpsell.SURFACE.PDP) || 'pdp_addons',
    handle: card.dataset.addonHandle || '',
    position: cards.indexOf(card) + 1
  };
}

/**
 * Impressions for the ADD-ONS carousel. Observed rather than counted on render:
 * this is a horizontal slider, and crediting cards nobody scrolled to would make
 * it look better than the surfaces where every card is visible.
 */
function initAddonImpressions() {
  if (!window.mgUpsell) return;
  document.querySelectorAll('.product-addons__card[data-addon-card]').forEach(card => {
    window.mgUpsell.observe(card, addonTrackFields(card));
  });
}

function initAddonSelection() {
  const addons = document.querySelectorAll('.product-addons__checkbox');

  initAddonImpressions();

  addons.forEach(addon => {
    const addonProductId = addon.getAttribute('data-addon-id');
    const addonModalId = `addon-modal-${addonProductId}`;
    const addonModal = document.querySelector(`#${addonModalId}`);
    const doesModalExist = addonModal ? true : false;

    addon.addEventListener('change', function () {
      const addToCartButton = document.querySelector('#product-add-to-cart');
      if (addon.checked) {
        if (window.mgUpsell) {
          window.mgUpsell.click(addonTrackFields(addon.closest('.product-addons__card')));
        }
        if (doesModalExist) {
          addonModal.classList.add('active');
          addonModal.closest('.addon-modals').classList.add('open');
          document.body.classList.add('overflow--hidden');
        }
      }
      // update ATC button
      if (addToCartButton) {
        const noOfSelectedAddonItems = 1 + Number(document.querySelectorAll('.product-addons__checkbox:checked').length);
        const atcBtnText = noOfSelectedAddonItems <= 1 ? 'Add to Cart' : `Add to Cart(${noOfSelectedAddonItems} Items)`;
        addToCartButton.value = atcBtnText;
      }
    });
  })
}

/**
 * Initialize Add-on options selection modals
 * @returns 
 */
function initAddonModals() {
  const modalsWrapper = document.querySelector('.addon-modals');
  if (!modalsWrapper) return;

  const closeModal = (modalWrapper) => {
    if (!modalWrapper) return;

    modalWrapper.classList.remove('open');
    document.body.classList.remove('overflow--hidden');
    const activeModals = modalWrapper.querySelectorAll('.addon-modal.active');

    if (!activeModals) return;

    activeModals.forEach(activeModal => {
      activeModal.classList.remove('active');
    });
  }

  modalsWrapper.addEventListener('click', function (event) {
    const isCloseTrigger = event.target.matches(".button-close-modal") || !(
      event.target.closest(".addon-modal") ||
      (event.target.classList && event.target.classList.contains("addon-modal"))
    );
    if (!isCloseTrigger) {
      return;
    }

    closeModal(modalsWrapper)
  });

  // individual modals
  const addonModals = modalsWrapper.querySelectorAll('.addon-modal');
  addonModals.forEach(addonModal => {
    addonModal.querySelector('.button--select').addEventListener('click', function (e) {
      closeModal(modalsWrapper)
    });
  });
}

/**
 * Initialize product option selection inside the modal
 */
function inputProductOptionSelection() {
  const swatches = document.querySelectorAll('.addon-option__selector__swatch');

  /**
   * Option values currently selected in ONE add-on's popup, positionally aligned
   * with that product's `variant.options` array.
   *
   * This used to read `document.querySelectorAll('.addon-option__selector__swatch')`
   * — every swatch on the page — and flatten every modal's selection into one array.
   * With several add-ons open that produced e.g. ["Black", "Black/Black", "Black",
   * "White"], and findVariantFromOptions() then compared THIS product's
   * `variant.options[0]` against another add-on's colour. Only the first modal on
   * the page ever resolved correctly; every other add-on silently staged its default
   * variant, so a shopper who picked White on the wireless charger was sold Black.
   *
   * One entry per OPTION GROUP rather than per checked radio, so the indices stay
   * aligned even when a group has nothing selected — possible since PR #97 disables
   * values with no available variant. An unselected group yields null, which matches
   * no variant, so findVariantFromOptions() returns undefined and the caller leaves
   * the staged variant alone instead of guessing.
   *
   * @param {Element} modal the `.addon-modal` being interacted with
   * @returns {Array<string|null>}
   */
  const getSelectedOptions = (modal) => {
    return Array.from(modal.querySelectorAll('.addon-option')).map(group => {
      const checkedOption = group.querySelector('input[type="radio"]:checked');
      return checkedOption ? checkedOption.value : null;
    });
  }

  const findVariantFromOptions = (variants, optionValues) => {
    const currentVariant = variants.find((variant) => {
      return !variant.options.map((option, index) => {
        return optionValues[index] === option;
      }).includes(false);
    });

    return currentVariant;
  }

  const getAddonCard = (product_id) => {
    const box = document.querySelector(`#addon-${product_id}`);
    return box ? box.closest('.product-addon') : null;
  };

  const updateAddonPrice = (variant, product_id) => {
    if (!variant) return;

    const modal = document.querySelector(`#addon-modal-${product_id}`);
    const priceContainer = modal.querySelector('.addon-modal__price');

    // `product-price.liquid` is rendered here with `addon: true`, which prefixes
    // every class (`addon-price`, `addon-compare-price`, `addon-price-save`), so
    // the bare `.price` / `.compare-price` lookups always came back null and this
    // whole function silently no-opped — the popup kept showing the price Liquid
    // baked in (`product.price`, i.e. the CHEAPEST variant) no matter which swatch
    // was picked. Match both spellings so it works either way.
    const retailPrice = priceContainer.querySelector('.addon-price, .price');
    const compareAtPrice = priceContainer.querySelector('.addon-compare-price, .compare-price');
    const savePercentage = priceContainer.querySelector('.addon-price-save, .price-save');

    // Re-apply the "buy together" % this add-on was rendered with, using the same
    // integer math as product-addon-card.liquid (which stamps it on the card as
    // data-addon-pct). Without it the popup shows the raw variant price while the
    // cart still charges the discounted one — $93.73 on the page, $56.24 at
    // checkout for a 2-arm monitor mount.
    const card = getAddonCard(product_id);
    const pct = Number(card && card.dataset.addonPct) || 0;
    const payCents = variant.price - Math.floor((variant.price * pct) / 100);
    // With a buy-together % the crossout is the variant's own price; otherwise it
    // falls back to the variant's compare-at price.
    const wasCents = pct > 0 ? variant.price : variant.compare_at_price;

    if (retailPrice) {
      const _price = Shopify.formatMoney(payCents, window.addon.money_format)
      retailPrice.innerHTML = _price;
      updatePriceInAddonCards(product_id, _price);
    }

    if (wasCents > payCents) {
      if (compareAtPrice) {
        compareAtPrice.innerHTML = Shopify.formatMoney(wasCents, window.addon.money_format);
        compareAtPrice.style.display = 'inline';
      }

      if (savePercentage) {
        const percentage = (wasCents - payCents) * 100 / wasCents;
        savePercentage.innerHTML = `(Save ${Math.floor(percentage)}%)`;
        // was `compareAtPrice.style.display` here — a typo that also threw
        // whenever the crossout element was absent.
        savePercentage.style.display = 'inline';
      }
    } else {
      if (compareAtPrice) {
        compareAtPrice.style.display = 'none';
      }
      if (savePercentage) {
        savePercentage.style.display = 'none';
      }
    }
  }

  const updatePriceInAddonCards = (product_id, price) => {
    // The slider card keeps its price OUTSIDE the <label>, so this lookup found
    // the label but no `.addon-price` inside it and threw on null — aborting the
    // rest of updateAddonPrice, which left the crossout stale AND skipped
    // updateAddonVariantId, so the shopper's chosen variant never got staged and
    // the default one went into the cart.
    const addonCard = getAddonCard(product_id);
    const priceEl = addonCard && addonCard.querySelector('.addon-price');
    if (priceEl) priceEl.innerHTML = `+${price}`;
  };

  const updateAddonVariantId = (variant, product_id) => {
    if (!variant) return;

    const addon = document.querySelector(`#addon-${product_id}`);
    if (addon) {
      addon.setAttribute('data-variant-id', variant.id);
    }
  }

  const updateAddonImage = (variant, parent) => {
    if (!variant) return;
    if (!variant?.featured_image?.src) return;

    console.log(variant.featured_image.src);
    Shopify.Image.switchImage(variant.featured_image, parent.querySelector('.addon-modal__image img'));
  }

  swatches.forEach(swatch => {
    const modal = swatch.closest('.addon-modal');
    const id = modal.getAttribute('id').split('-').pop();
    if (!id) return;

    swatch.querySelector('input[type="radio"]').addEventListener('change', function () {
      const productVariants = JSON.parse(modal.querySelector(`#ProductJson-${id}`).innerHTML);
      const options = getSelectedOptions(modal);
      const variant = findVariantFromOptions(productVariants, options);
      const optionContainer = swatch.closest('.addon-option');
      const selectedOptionEle = optionContainer.querySelector('.addon-option__name span');
      if (selectedOptionEle && this.checked) {
        selectedOptionEle.textContent = this.value;
      }
      // Abdul Changes
      productVariants.forEach(variant => {
        if (swatch.classList.contains('addon-option__selector__swatch--color')) {
          if (swatch.querySelector('input[type="radio"]').checked) {
            let colorSwatchInput = swatch.querySelector('input[type="radio"]');
            if (variant.option1 == colorSwatchInput.value) {
              if (variant.available == false) {
                myFunction(variant);
                // Checking Update
                const swatches = document.querySelectorAll('.addon-option__selector__swatch');
                swatches.forEach((newSwatch) => {
                  if (!(newSwatch.classList.contains('addon-option__selector__swatch--color'))) {
                    if (!(newSwatch.classList.contains('no'))) {
                      let newCheckedEle = newSwatch.querySelector('input[type="radio"]');
                      newCheckedEle.setAttribute('checked', '');
                    }
                  }
                });
              }
            }
          }
        }
      });
      // ENdChanges
      if (variant) {
        updateAddonPrice(variant, id);
        updateAddonVariantId(variant, id);
        const parent = selectedOptionEle
        updateAddonImage(variant, optionContainer.closest('.addon-modal__content'));
      }
    });
  });
}


/**
 * Show (or clear) a cart failure next to the Add to Cart button.
 *
 * /cart/add.js is all-or-nothing: if ONE line is rejected, none of them are added.
 * A single sold-out add-on therefore 422s the whole batch and the main product never
 * reaches the cart. That error used to go to console.error and return, so the shopper
 * clicked the big orange button and literally nothing happened — no drawer, no line
 * item, no message. Never swallow it again.
 *
 * The element is created on demand rather than in Liquid so this needs no change to
 * product-template.liquid, which marketing and apps rewrite constantly.
 */
function setCartError(form, message) {
  if (!form) return;

  // Append to `.groups-btn` — the flex row (flex-wrap: wrap) holding qty + the
  // button — so a full-width child lands on its own line and the row grows.
  //
  // Do NOT anchor to `.atc-btn`: a sticky-add-to-cart script wraps it in a
  // `.sticky-wrapper` with a hard 50px height at runtime, so a notice placed in
  // there cannot push anything down and overlapped the Add-Ons carousel below.
  const host = form.querySelector('.groups-btn') || form;
  let errorEl = host.querySelector(':scope > .atc-error');

  if (!message) {
    if (errorEl) errorEl.remove();
    return;
  }

  if (!errorEl) {
    errorEl = document.createElement('div');
    errorEl.className = 'atc-error';
    // Announce it: the button gives no other feedback that the click failed.
    errorEl.setAttribute('role', 'alert');
    host.appendChild(errorEl);
  }

  errorEl.textContent = message;
}

/* Cartbot (the installed cart app) replaces window.fetch with its own wrapper,
   and that wrapper can throw SYNCHRONOUSLY — observed live on a desk PDP as
   "TypeError: Cannot read properties of null (reading 'items')", with this
   file's fetch call at the bottom of the stack.

   A synchronous throw escapes the promise chain entirely: .catch() and
   .finally() never run. In handleAddToCart that is silent and total — the click
   has already been preventDefault()ed and stopImmediatePropagation()ed, so the
   native submit cannot happen either, the button keeps spinning on "is-adding"
   for ever, and the shopper gets no product and no error.

   Converting the throw into a rejected promise is enough: the existing
   .catch()/.finally() then do exactly what they were written to do. */
function safeFetch(url, options) {
  try {
    return fetch(url, options);
  } catch (err) {
    return Promise.reject(err);
  }
}

function initAddToCart() {
  const root = document.documentElement;
  if (root.dataset.cartDrawerBound === 'true') return;

  root.dataset.cartDrawerBound = 'true';

  const handleAddToCart = function (e) {
    const clickedButton = e.type === 'click' && e.target.closest
      ? e.target.closest('#product-add-to-cart')
      : null;
    const submittedForm = e.type === 'submit' && e.target.matches('#add-to-cart-form')
      ? e.target
      : null;

    if (!clickedButton && !submittedForm) return;

    const addToCartForm = submittedForm || clickedButton.closest('#add-to-cart-form');
    const addToCartButton = clickedButton || addToCartForm?.querySelector('#product-add-to-cart');
    if (!addToCartForm || !addToCartButton) return;

    if (AJAX_CART_ENABLE) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    const addToCartButtonWrapper = addToCartButton.closest('.atc-btn');
    if (addToCartButtonWrapper) addToCartButtonWrapper.classList.add("is-adding");
    setCartError(addToCartForm, null);
    const addons = addToCartForm.querySelectorAll('.product-addon');
    const selectedAddonsFlags = [];
    const addonItems = [];
    const serializeForm = function (form) {
      const formData = new FormData(form);
      const item = {
        id: formData.get('id'),
        quantity: Number(formData.get('quantity') || 1)
      };
      const sellingPlan = formData.get('selling_plan');
      const properties = {};

      for (const [key, value] of formData.entries()) {
        const propertyMatch = key.match(/^properties\[(.+)\]$/);
        if (propertyMatch && value !== '') {
          properties[propertyMatch[1]] = value;
        }
      }

      if (sellingPlan) item.selling_plan = sellingPlan;
      if (Object.keys(properties).length) item.properties = properties;

      return item;
    };

    for (let i = 0; i < addons.length; i++) {
      const addon = addons[i];
      const isSelected = addon.querySelector('input[type="checkbox"]').checked;

      selectedAddonsFlags.push(isSelected);

      if (isSelected) {
        addonItems.push({
          quantity: 1,
          id: addon.querySelector('input[type="checkbox"]').getAttribute('data-variant-id'),
          properties: {
            "addon": "yes"
          }
        })
      }
    }
    const isAnyAddonSelected = selectedAddonsFlags.includes(true);

    if (AJAX_CART_ENABLE) {
      // const formData = new FormData(addToCartForm);
      const formData = serializeForm(addToCartForm);
      const items = [
        {
          ...formData
        },
        ...addonItems
      ];



      const config = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': `application/json` }
      };
      config.body = JSON.stringify({ items });

      safeFetch(`${addToCartForm.getAttribute('action')}.js`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            console.error('Cart add failed:', response.description || response.message || response);
            setCartError(
              addToCartForm,
              response.description ||
                response.message ||
                'Sorry, we could not add this to your cart. Please try again.'
            );
            return;
          }

          // Unlike the other two surfaces, a PDP add-on is staged and only
          // reaches the cart with the main product — so this batch succeeding is
          // its add moment. One event per staged add-on, after confirmation.
          if (window.mgUpsell) {
            addons.forEach((addonCard, i) => {
              if (!selectedAddonsFlags[i]) return;
              window.mgUpsell.add(addonTrackFields(addonCard), {
                pct: Number(addonCard.dataset.addonPct) || 0,
                path: 'with_product'
              });
            });
          }

          const cart = await safeFetch(`/cart.js`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': `application/json` }
          }).then(response => response.json());
          console.log('Cart response after adding items:', cart);

          document.dispatchEvent(new CustomEvent('cart:open-drawer', { bubbles: true, detail: { cart } }));
        })
        .catch((e) => {
          console.error(e);
          setCartError(addToCartForm, 'Sorry, we could not reach the cart. Please try again.');
        })
        .finally(() => {
          if (addToCartButtonWrapper) addToCartButtonWrapper.classList.remove("is-adding");
        });
    }
  };

  // Delegation survives product-option apps replacing the product form after
  // page load. The submit listener also covers keyboard submissions.
  window.addEventListener('click', handleAddToCart, true);
  window.addEventListener('submit', handleAddToCart, true);
}


// New Coding
const swatches = document.querySelectorAll('.addon-option__selector__swatch');
swatches.forEach(swatch => {
  const getSelectedOptions = () => {
    const options = [];
    swatches.forEach(swatch => {
      const checkedOption = swatch.querySelector('input[type="radio"]:checked');
      if (checkedOption) {
        options.push(checkedOption.value);
      }
    });

    return options;
  }
  const findVariantFromOptions = (variants, optionValues) => {
    // Starts from Here
    const currentVariant = variants.find((variant) => {
      return !variant.options.map((option, index) => {
        return optionValues[index] === option;
      }).includes(false);
    });

    return currentVariant;
  }
  const modal = swatch.closest('.addon-modal');
  const id = modal.getAttribute('id').split('-').pop();
  if (!id) return;
  const productVariants = JSON.parse(modal.querySelector(`#ProductJson-${id}`).innerHTML);
  const options = getSelectedOptions();
  const variant = findVariantFromOptions(productVariants, options);
  productVariants.forEach(variant => {
    if (swatch.classList.contains('addon-option__selector__swatch--color')) {
      if (swatch.querySelector('input[type="radio"]').checked) {
        let colorSwatchInput = swatch.querySelector('input[type="radio"]');
        if (variant.option1 == colorSwatchInput.value) {
          if (variant.available == false) {
            myFunction(variant);
          }
        }
      }
    }

  });
});
function myFunction(newVariant) {
  console.log(newVariant);
  swatches.forEach(swatch => {
    let blockedElement = `<div class="bac-souldout"></div>`;
    swatch.classList.remove('no');
    swatch.querySelector('input[type="radio"]').removeAttribute('disabled');
    if (!swatch.classList.contains('addon-option__selector__swatch--color')) {
      if (swatch.querySelector('input[type="radio"]').value == newVariant.option2 || newVariant.option3) {
        swatch.classList.add('no');
        swatch.querySelector('input[type="radio"]').setAttribute('disabled', 'disabled');
        swatch.querySelector('input[type="radio"]').removeAttribute('checked');
        let blockedLabel = swatch.querySelector('label');
        blockedLabel.innerHTML += blockedElement;
      }
    }
  });
}
// New COding End

function getSwiperConfig() {
  const w = window.innerWidth;

  const slideCount = document.querySelectorAll(
    ".swiper-container-addons .swiper-slide"
  ).length;

  let slidesPerView = 2;
  let slidesPerGroup = 2;
  if(w > 1024) {
    slidesPerView = 3;
    slidesPerGroup = 3;
  }

  // slidesPerView = Math.min(slidesPerView, slideCount);
  // slidesPerGroup = Math.min(slidesPerGroup, slideCount);
  const effectiveSlidesPerView = Math.min(slidesPerView, slideCount);

  const navButtons = document.querySelectorAll('.addons-slider .swiper-nav');
  navButtons.forEach(btn => {
    btn.style.display = slideCount <= slidesPerView ? 'none' : '';
  });

  return {
    // slidesPerView,
    slidesPerView: effectiveSlidesPerView,
    slidesPerGroup,
    spaceBetween: 10,
    centeredSlides: false,
  };
}
